import type { Options } from "ky";

import { postJson } from "#app/lib/fetchClient";

import { GATEWAY_PATHS } from "../api-utils";

type PostUserHelpParams = {
  body: {
    captchaResponse: string;
    message?: string;
    phoneNumber?: string;
    emailAddress?: string;
  };
};

export async function postUserHelp(
  params: PostUserHelpParams & Pick<Options, "signal">,
): Promise<void> {
  // Call endpoint
  await postJson(
    `${GATEWAY_PATHS.externalBolRegistrationService}/User/Help`,
    { json: params.body, signal: params.signal },
    true,
  );
}
